import { render, staticRenderFns } from "./OrdersListKanban.vue?vue&type=template&id=8ebe75b6&scoped=true&"
import script from "./OrdersListKanban.vue?vue&type=script&lang=ts&"
export * from "./OrdersListKanban.vue?vue&type=script&lang=ts&"
import style0 from "./OrdersListKanban.vue?vue&type=style&index=0&id=8ebe75b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ebe75b6",
  null
  
)

export default component.exports